import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing24, spacing4 } from 'approot/shared/styles/spacing.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { grey10, grey5, grey6 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  FillInBlanksFieldCss,
  FillInBlanksFontSizeCss,
  FillInBlanksFontSizeProps,
  FillInBlanksLabelSupport,
  FillInBlanksPunctuationCss,
} from './fill-in-blanks-shared.style';

type FillInBlanksFieldProps = FillInBlanksFontSizeProps & {
  $colours: ColourItem;
  $minWidth: number;
  $punctuation: string | null;
  $hasLabel: boolean;
};

export const FillInBlanksField = styled.div<FillInBlanksFieldProps>`
  display: inline-flex;
  max-width: ${({ $minWidth }) => rem($minWidth)};
  width: 100%;

  ${FillInBlanksFontSizeCss}
  ${FillInBlanksFieldCss}
  ${FillInBlanksPunctuationCss}
`;

type FillInBlanksAnswerProps = {
  $minWidth: number;
  $colours: ColourItem;
  $label: string | null;
} & FillInBlanksFontSizeProps;
export const FillInBlanksAnswer = styled.div<FillInBlanksAnswerProps>`
  padding: 0;
  position: relative;
  width: 100%;

  .tiptap {
    ${FillInBlanksFontSizeCss}
    outline: none;
    width: 100%;

    p {
      margin-bottom: 0;
    }
  }

  ${FillInBlanksLabelSupport}
`;

type FillInBlanksEditTipTapWrapperProps = {
  $placeholder: string | null;
  $isScaffold: boolean;
} & FillInBlanksFontSizeProps;
export const FillInBlanksEditTipTapWrapper = styled.div<FillInBlanksEditTipTapWrapperProps>`
  ${FillInBlanksFontSizeCss}
  width: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;

  p {
    margin: 0;

    ${({ $placeholder, $isScaffold }) =>
      $placeholder &&
      `
      &:after {
        color: ${$isScaffold ? grey10 : grey6};
        content: '${$placeholder}';
        position: absolute;
        top: 0;
        pointer-events: none;
        white-space: nowrap;
      }
    `}
  }
`;

export const FillInBlanksEditTipTap = styled.div<FillInBlanksFontSizeProps>`
  ${FillInBlanksFontSizeCss}
  outline: none;
  width: 100%;
  padding: 0;
  position: relative;
`;

export const FillInBlanksEditSentence = styled.div`
  min-height: ${rem(48)};
  padding: ${rem(spacing4)} ${rem(spacing24)};
  position: relative;

  & > div:first-child {
    margin-left: 0;
  }
`;

type FillInBlanksEditTriggerProps = {
  $isActive: boolean;
  $showOutline?: boolean;
};
export const FillInBlanksEditTrigger = styled.button<FillInBlanksEditTriggerProps>`
  background: transparent;
  border: none;
  border-radius: ${rem(2)};
  display: block;
  position: absolute;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  ${({ $showOutline }) =>
    $showOutline &&
    `
    &:hover {
      border-radius: ${rem(borderRadius8)};
      border: 1px solid ${grey5};
      inset: 0;
      cursor: pointer;
    }
  `}

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: 1px solid ${grey10};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      outline: 1px solid ${grey10};
  `}
`;

export const FillInBlanksEditTriggerAnswer = styled(FillInBlanksEditTrigger)`
  z-index: 1;
`;
